import { mapStateToLayoutProps, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { LAYOUT_STEPPER_RANK } from './RenderersRanks';
export const LayoutStepperRendererTemplate = html `
  <template>
    <stepper-wrapper :form=${(x) => x} :control=${(x) => x.control}></stepper-wrapper>
  </template>
`;
export const LayoutStepperRendererEntry = {
    renderer: LayoutStepperRendererTemplate,
    tester: rankWith(LAYOUT_STEPPER_RANK, (uiSchema) => uiSchema.type === 'Stepper'),
    mapper: mapStateToLayoutProps,
};
